import { useQuery } from "@tanstack/react-query"
import { getBackofficeCompaniesQuery } from "modules/backoffice/lib/companies/getBackofficeCompaniesQuery"

export function useGetBackofficeCompaniesQuery(
  ...args: Parameters<typeof getBackofficeCompaniesQuery>
) {
  return useQuery(getBackofficeCompaniesQuery(...args))
}
